<template>
	<div class="header">
		<!-- 折叠按钮 -->
		<!-- <div :class="{logo:true,logoSmall:collapse}" class="66" @click="collapseChage">
        <div v-if="!collapse" class="left-title">
            <img src="../../assets/images/logo02.png" alt="" >
            <span>后台管理</span>
        </div>
        <img src="../../assets/images/logo01.png" alt="" v-else>
    </div>-->
		<div class="header-right" @click="getPermissions">
			<div class="flex-row">
				<div class="logo">
					<img src="../../assets/images/new/head_logo.png" @click="gotoCenter" alt />
				</div>
				<el-menu class="sidebar-el-menu" :default-active="onRoutes" mode="horizontal" background-color="#111"
					text-color="#fff" active-text-color="#333" router @select="handleSelect">
					<template v-for="item in items">
						<el-menu-item class="el-menu-item" :index="item.url" :key="item.id"
							:route="{ path: '/' + item.url }">
							<template slot="title">
								<i :class="item.icon" class="icon"></i>
								<span class="text">{{ item.name }}</span>
							</template>
						</el-menu-item>
					</template>
				</el-menu>
			</div>
			<div class="message">
				<!-- <div class="bell-box">
          <el-image class="img" :src="require('../../assets/images/data/bell.png')"></el-image>
          <sup class="text">88</sup>
        </div>-->

				<el-popover placement="bottom-end" width="160" style="top: 60px;" v-model="visible" class="el-dropdowns">
					<div class="popover-box">
						<div class="user-name update-shop-msg">
							<p class="user-label">当前用户</p>

							<p class="user-value">{{ userInfo.staffName }} ({{ userInfo.staffNo }})</p>
						</div>

						<div class="user-name update-shop-msg" @click="handleCommand">
							<p class="user-label">当前门店</p>
							<p class="user-value">{{ userInfo.selectShopName }}</p>
							<img src="../../assets/images/new/arrow_right.png" alt="">
						</div>
						<div class="user-name update-shop-msg">
							<p class="user-label">入职时间</p>
							<p class="user-value">{{ formatDay(userInfo.shopJoinTime) }}</p>
						</div>
						<div class="user-name update-shop-msg">
							<p class="user-label">电话</p>
							<p class="user-value">{{ userInfo.mobile }}</p>
						</div>
						<div class="update-shop-msg" @click="updateLoginPsd">
							<p class="user-label">修改登陆密码</p>
							<img src="../../assets/images/new/arrow_right.png" alt="">
						</div>
						<div class="update-shop-msg" @click="orderShopServe"
							v-if="shopServe.length > 0">
							<p class="user-label">订购门店服务</p>
							<img src="../../assets/images/new/arrow_right.png" alt="">
						</div>
						<div class="update-shop-msg" @click="updateShop"
							v-perm="{ key: 'shopInfo', value: 'shopInfo:detail' }">
							<p class="user-label">修改店铺信息</p>
							<img src="../../assets/images/new/arrow_right.png" alt="">
						</div>
            
						<!-- 	v-perm="{ key: 'rolePermManager', value: 'rolePermManager:list' }" -->
						<div class="update-shop-msg" @click="authManagement" v-perm="{ key: 'rolePermManager', value: 'rolePermManager:list' }">
							<p class="user-label">角色权限管理</p>
							<img src="../../assets/images/new/arrow_right.png" alt="">
						</div>
						<div class="update-shop-msg" @click="versionUpdate">
							<p class="user-label">版本更新</p>
							<img src="../../assets/images/new/arrow_right.png" alt="">
						</div>
						<div class="update-shop-msg" @click="toggleSystem">
							<p class="user-label">切换至商家后台</p>
							<img src="../../assets/images/new/arrow_right.png" alt="">
						</div>
						<!-- <div class="update-shop-msg" @click="quitChange">
              <p class="user-label">离职申请</p>
              <img src="../../assets/images/new/arrow_right.png" alt="">
            </div> -->
						<div class="update-shop-msg" @click="quit">
							<p class="user-label">退出登录</p>
							<img src="../../assets/images/new/logout.png" alt="">
						</div>
					</div>
					<!--  -->
					<div class="header-img" slot="reference">
						<div class="block">
							<el-avatar class="staff-head-img" :size="30" :src="userInfo.staffImgUrl" v-if="userInfo.staffImgUrl"></el-avatar>
							<el-avatar class="staff-head-img" :size="30" :src="circleUrl" v-else></el-avatar>
							<p class="shop-name">{{ userInfo.selectShopName }}</p>
							<img src="../../assets/images/new/head_under.png" alt="">
						</div>
					</div>
				</el-popover>
			</div>
		</div>
		<header-edit ref="addEditForm" @handleChange="changeAddEdit"></header-edit>
		<header-edit-user ref="addEditUserForm" @handleChange="changeAddEdit"></header-edit-user>
		<update-psd ref="updatePsd" @handleChange="changeAddEdit"></update-psd>
		<company-quit ref="companyQuitForm"></company-quit>
	</div>
</template>

<script>
import minxin from "../../assets/javascript/minxin";
import updatePsd from "../../components/common/modifyPwd";
import headerEdit from "./header-edit";
import companyQuit from "../../page/manage/staffManage/companyQuit";
import headerEditUser from "./header-editUser";
import { menuInfoSet } from "../../assets/javascript/menu";
export default {
	components: {
		headerEdit,
		headerEditUser,
		updatePsd,
		companyQuit
	},
	inject: ["reload"],
	mixins: [minxin],
	data() {
		return {
			visible: false,
			circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
			collapse: false,
			fullscreen: false,
			userInfo: "",
			list: [],
			appInfo: this.$store.getters.AppInfo || {
				user: {},
				orgList: []
			},
			items: [],
			shopInfo: this.$store.getters.ShopInfo,
			shopListHide: false,
			isSelected: "",
			menuInfo: [],
			loadFlag: false,
			shopId: "",
			smsServe: [],
			shopServe: []
		};
	},

  created () {    
    console.log(1);
		if (localStorage.getItem("dataList")) {
			this.menuInfo = JSON.parse(localStorage.getItem("dataList"));
			this.initMenu();
		} else {
			this.init();
		}
		if (localStorage.getItem("mainMenuList")) {
			this.initMainMenuList();
		} else {
			this.getMainMenuList();
		}
    this.userInfo = JSON.parse(localStorage.getItem("shopInfo"));
    this.statistical();
    this.getAppInit();
	},
	computed: {
		onRoutes() {
			return this.$route.path.split("/")[1];
		},
	},
	methods: {
		getPermissions() {
			let permissions = localStorage.getItem("permissions");
			permissions = JSON.parse(permissions)
			this.shopServe = permissions.shopServe
			console.log(this.shopServe);
    },
    getAppInit() {
			this.$api.get(this.$url.appInit).then((res) => {
				if (res) {
					console.log(res);
					sessionStorage.setItem("appInit", JSON.stringify(res))
				}
			})
		},
		initMainMenuList() {
			this.items = JSON.parse(localStorage.getItem("mainMenuList"));
			console.log("this.items", this.items);
			if (this.items) {
				for (let i in this.items) {
					let code = this.items[i].code;
					if (code == "collectMoney") {
						this.$set(this.items[i], "id", 1);
						this.$set(this.items[i], "icon", "el-icon-money");
						this.$set(this.items[i], "url", "collectMoney");
					} else if (code == "shop") {
						this.$set(this.items[i], "id", 2);
						this.$set(this.items[i], "icon", "el-icon-menu");
						this.$set(this.items[i], "url", "manage");
					} else if (code == "member") {
						this.$set(this.items[i], "id", 3);
						this.$set(this.items[i], "icon", "el-icon-menu");
						this.$set(this.items[i], "url", "member");
					} else if (code == "order") {
						this.$set(this.items[i], "id", 4);
						this.$set(this.items[i], "icon", "el-icon-s-order");
						this.$set(this.items[i], "url", "orderInfo");
					} else if (code == "workPlateForm") {
						this.$set(this.items[i], "id", 5);
						this.$set(this.items[i], "icon", "el-icon-s-data");
						this.$set(this.items[i], "url", "dataList");
					}
				}
			}
		},
		getMainMenuList() {
			this.$api.post(this.$url.common.mainMenuList).then(res => {
				if (res) {
					localStorage.setItem("mainMenuList", JSON.stringify(res))
					this.initMainMenuList();
				}
			});
		},
		statistical() {
			var _hmt = _hmt || [];
			(function () {
				var hm = document.createElement("script");
				hm.src = "https://hm.baidu.com/hm.js?cd31e8c6e1f615f7a5939f15af7f941d";
				var s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(hm, s);
			})();
		},
    handleSelect (key) {
			if (key == 'collectMoney') {
				this.$store.commit("setCurentPage", 'cashier');
			} else if (key == 'manage') {
				this.$store.commit("setCurentPage", 'shop');
			} else if (key == 'dataList') {
				this.$store.commit("setCurentPage", 'data');
			}
		},
		versionUpdate() {
			this.$router.push("/orderInfo/versionUpdate")
		},
		orderShopServe() {
			this.$router.push("/manage/shopServeed")
		},
		quitChange() {
			this.$set(obj, 'id', this.userInfo.staffId)
			this.$refs["companyQuitForm"].$emit("set", obj);
			this.visible = false;
		},
		gotoCenter() {
			this.$router.push("/" + this.items[0].url);
		},
		//登出
		quit() {
			this.$api.post(this.$url.logout, {}).then(res => {
				if (res) {
					this.$store.commit("setLoginUser", null);
					this.$router.push("/ssoLogin");
					sessionStorage.clear();
					localStorage.clear();
				}
			});
		},
		handleCommand(command) {
			this.$router.push("/center");
		},
		getMenusHead() {
			this.$api.post(this.$url.common.allMenuList, {
				queryFrom: "pc",
			})
				.then(res => {
					if (res) {
						this.$store.commit("setShowMenus", res);
					}
				})
				.catch(error => { });
		},
		updateShop(row) {
			this.visible = false;
			this.$refs["addEditForm"].$emit("set", JSON.parse(localStorage.getItem("shopInfo")).shopId);
		},
		// 角色权限管理
		authManagement() {
			this.visible = false
			this.$router.push({
				path: '/dataList/authManagement',
			})
		},
		updateLoginPsd() {
			this.visible = false;
			this.$refs["updatePsd"].$emit("open", this.userInfo);
		},
		changeAddEdit() {},
		init() {
			this.$api.post(this.$url.common.dataMenuList, {
				queryFrom: "pc"
			}).then(res => {
				if (res) {
					this.menuInfo = res;
					localStorage.setItem("dataList", JSON.stringify(res))
					this.initMenu();
				}
			});
		},
		initMenu() {
			if (this.menuInfo) {
				menuInfoSet(this.menuInfo)
			}
		},
		toggleSystem() {
			let url = 'https://merchant-health.yuansikang.com/h5/#/ssoLogin'
			if (window.location.href.indexOf('testapi') > 0) {
				url = 'https://testmerchant-health.yuansikang.com/h5/#/ssoLogin'
			} else {
				url = 'https://merchant-health.yuansikang.com/h5/#/ssoLogin'
			}
			var a = document.createElement('a');
			a.href = `${url}?token=${this.$store.getters.AppInfo.accessToken}`;
			document.body.appendChild(a)
			a.click()
			a.remove()
		}
	}
};
</script>
<style lang="less">
div .el-menu--popup-bottom-start {
	margin-top: 2px;
}
</style>
<style lang="less" scoped>
@import "../../assets/css/edit.less";
@primary: #336fed;

.el-dropdown-link {
	margin-left: 15px;
}

.el-dropdown-link .shop-name {
	width: 245px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.popover-box {
	.user-msg {
		padding: 20px 0;
		border-bottom: 1px solid #EBEDF0;
		display: flex;
		align-items: center;

		&:hover {
			cursor: pointer;
		}

		.user-label {
			width: 70px;
			color: #333;
			font-size: 16px;
			font-weight: 500;
		}

		.user-value {
			margin-left: 15px;
			font-size: 14px;
			color: #8d8d8d;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
		}
	}

	.update-shop-msg {
		padding: 20px 0;
		border-bottom: 1px solid #EBEDF0;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.user-label {
			min-width: 100px;
			color: #333;
			font-size: 16px;
			font-weight: 500;
		}

		&:hover {
			cursor: pointer;
		}
	}

	.icon {
		font-size: 16px;
		color: @blue;
		font-weight: bold;
	}
}

.bell-box {
	margin-right: 30px;
	position: relative;

	.img {
		margin-top: 5px;
	}

	.text {
		font-size: 12px;
		width: 15px;
		text-align: center;
		height: 15px;
		line-height: 15px;
		background: red;
		color: #fff;
		border-radius: 50%;
		padding: 2px;
		position: absolute;
		top: -5px;
		left: 10px;
	}
}

.header {
	position: relative;
	box-sizing: border-box;
	width: 100%;
	height: 58px;
	font-size: 22px;
	color: #fff;
}

.header {
	.el-menu-item {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		width: 104px;

		&:hover {
			background: #333 !important;
		}

		.icon {
			margin-right: 10px;
		}
	}

	.header-right {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.logo {
			width: 110px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 49px 0 17px;

			img {
				width: 100%;
				cursor: pointer;
			}
		}

		.message {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-right: 30px;
			cursor: pointer;

			.header-img {
				height: 32px;

				.block {
					display: flex;
					align-items: center;

					.staff-head-img {
						margin-right: 10px;
					}
				}
			}

			.staff-name {
				font-size: 0.18rem;
			}

			.shop-name {
				font-size: 14px;
				color: #fff;
			}

			.icons {
				font-size: 0.3rem;
				color: #fff;
				align-items: center;
				display: flex;
			}
		}
	}

	/deep/ .is-active {
		color: #fff !important;
		background: #333 !important;
	}

	/deep/ .el-menu.el-menu--horizontal {
		border-bottom: 0;
	}

	// /deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
	//   border-bottom: 0;
	// }
}

/deep/ .el-menu--horizontal>.el-submenu {
	width: 104px;

	.el-submenu__title {
		font-size: 18px;
		height: 70px;
		line-height: 65px;
		padding: 0 8px;
	}

	.icons {
		margin-right: 10px;
		font-size: 22px;
		color: #fff;
	}

	&:hover {
		background: rgba(122, 153, 191, 0.4) !important;
	}
}

/deep/ .is-opened .el-submenu__title {
	background: rgba(122, 153, 191, 0.4) !important;
}

div.el-menu--horizontal {
	width: 1000px;

	.el-menu.el-menu--popup {
		min-width: 187px;

		.el-menu-item {
			background: #fff !important;
			// border-bottom: 1px solid @borderColor;
			text-align: center;
			color: #333 !important;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 10px 0;
			height: auto;
			line-height: auto;
			font-size: 16px;
			font-weight: bold;
			margin-top: -10px;

			&:first-child {
				border-top-left-radius: 10px;
				border-top-right-radius: 10px;
			}

			&:last-child {
				border-bottom-left-radius: 10px;
				border-bottom-right-radius: 10px;
			}

			.icon {
				font-size: 32px;
				margin-right: 18px;
			}

			&:hover {
				background: rgba(255, 255, 255, 0.9) !important;
			}

			i {
				color: #fff;
			}
		}
	}
}

// /deep/ .el-menu--horizontal > .el-submenu:hover {
//   background: rgba(122, 153, 191, 0.4) !important;
// }
.staff-head-img {
	/deep/img {
		width: 100%;
	}
}

/deep/ div.el-menu--horizontal .el-menu.el-menu--popup .el-menu-item {
	height: auto;
	line-height: auto;
	border-bottom: 0;
}

/deep/ .el-menu {
	&::before {
		border: 0;
	}
}

/deep/ .el-popper[x-placement^="bottom"] .popper__arrow {
	top: -17px;
	margin-right: 28px;
}

/deep/ .el-popper .popper__arrow {
	border-width: 16px !important;

	&::after {
		border-width: 16px !important;
	}
}

/deep/ div.el-popper[x-placement^="bottom"] .popper__arrow::after {
	margin-left: -16px;
}
</style>
